export const DEFAULT_FONT_SIZE_IN_PX = 20;

export const TINY_BREAKPOINT_IN_PX = 364;
export const MOBILE_BREAKPOINT_IN_PX = 768;
export const TABLET_BREAKPOINT_IN_PX = 1024;
export const LAPTOP_BREAKPOINT_IN_PX = 1200;

export const TINY_SIZE_IN_PERCENTAGE = 0.59;
export const MOBILE_SIZE_IN_PERCENTAGE = 0.59;
export const TABLET_SIZE_IN_PERCENTAGE = 0.75;
export const LAPTOP_SIZE_IN_PERCENTAGE = 0.88;

export const CARD_READER_ZOOM_1_IN_PERCENTAGE = 0.68;
export const CARD_READER_ZOOM_2_IN_PERCENTAGE = 0.93;
export const CARD_READER_ZOOM_1_MOBILE_IN_PERCENTAGE = 0.71;
export const CARD_READER_ZOOM_2_MOBILE_IN_PERCENTAGE = 1.33;

export const MOBILE_BACK_BUTTON_HEIGHT = 45;
export const TABLET_BACK_BUTTON_HEIGHT = 100;
export const LAPTOP_BACK_BUTTON_HEIGHT = 140;

export const TICKET_TYPE_VALUE_TICKET = 'valueTicket';
export const TICKET_TYPE_EXTRA_TICKET = 'extraTicket';
export const TICKET_TYPE_SEASONAL_TICKET = 'seasonalTicket';
export const TICKET_TYPE_ADDITIONAL_ZONE = 'additionalZoneTicket';

export const FULL_SCREEN_MODE_KEY = 'fullScreenMode';
export const MAX_PASSENGERS_COUNT = 63;
